import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { FacultyListItem } from "../types";

type Props = {
  faculty: FacultyListItem | null;
  onClose: () => void;
  onEdit: (facultyId: number) => void;
};

/** Read-only popup: what one faculty teaches in the active year, as grade -> section -> subjects. */
const TeachesDialog: React.FC<Props> = ({ faculty, onClose, onEdit }) => (
  <Dialog open={Boolean(faculty)} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
    <DialogTitle sx={{ fontWeight: 600, pb: 1.5 }}>
      {faculty?.name}
      {faculty?.academicYear && (
        <Typography component="span" color="text.secondary" ml={1}>
          — {faculty.academicYear}
        </Typography>
      )}
    </DialogTitle>
    <Divider />
    <DialogContent sx={{ pt: 2 }}>
      {faculty?.teaches.map((grade) => (
        <Box key={grade.grade} mb={1.5}>
          <Typography fontWeight={600}>{grade.grade}</Typography>
          {grade.sections.map((section) => (
            <Box key={section.section} display="flex" gap={2} pl={2}>
              <Typography sx={{ minWidth: 40 }}>{section.section}</Typography>
              <Typography color="text.secondary">{section.subjects.join(", ")}</Typography>
            </Box>
          ))}
        </Box>
      ))}
    </DialogContent>
    <Divider />
    <DialogActions sx={{ p: 2 }}>
      <Button onClick={() => faculty && onEdit(faculty.id)}>Edit</Button>
      <Button variant="contained" onClick={onClose}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default TeachesDialog;
